// import { API_PREFIX } from "@douban/rexxar-common/es/assets/js/Globals";
// import request from "@douban/rexxar-common/es/assets/js/request";
// import { User } from '@douban/frodo-rexxar-components/es/common/types';

import { useState, useEffect } from 'react'
import { AxiosResponse, AxiosError } from 'axios';
import { Cookie, axios, setQuery } from '@douban/fe-utils';
import { User } from '@douban/frodo-types';
// import { Cookie, challengeKeyInterceptor } from '@douban/fe-utils'
import axiosInstance from '@src/common/utils/axios-instance'
import { HomeDataScheme } from '@src/common/types'
import { API_COLLECT_GIFT, API_COLLECT_INVITATION_LETTER } from './const';

export function getData(api: string, params?: {[key: string]: unknown}) {
  const axiosConfig = {
    url: api,
    // adapter: jsonpAdapter,
    // callbackParamName: 'callback',
    params
  }

  return new Promise<HomeDataScheme | null>((resolve, reject) => {
    axiosInstance(axiosConfig).then((res) => {
      if (res.status === 200) {
        if (!res.data.r) {
          resolve(res.data)
        } else {
          reject(res.data)
        }
      }
      resolve(null)
    }).catch((error) => {
      /*
      if (error.response) {
        // 请求成功发出且服务器也响应了状态码，但状态代码超出了 2xx 的范围
        // console.log(error.response.data);
        // console.log(error.response.status);
        // console.log(error.response.headers);
      } else if (error.request) {
        // 请求已经成功发起，但没有收到响应
        // `error.request` 在浏览器中是 XMLHttpRequest 的实例，
        // 而在node.js中是 http.ClientRequest 的实例
        // console.log(error.request);
      } else {
        // 发送请求时出了点问题
        // console.log('Error', error.message);
      }
      */
      reject(error.response)
    })
  })
}


// 获取登录用户
export const REXXAR_API_PREFIX = 'https://m.douban.com/rexxar/api/v2';
export const LOGIN_USER_API = `${REXXAR_API_PREFIX}/~me`;

export function getLoginUser() {
  return axiosInstance.get(LOGIN_USER_API, { params: { ck: Cookie.get('ck') } }).then((res: AxiosResponse<User | null>) => {
    return res.data
  })
}

export function useLoginUser() {
  const [state, setState] = useState<{
    user?: User | null
    pending?: boolean
  }>()

  const _get = async () => {
    setState({ ...state, pending: true })
    try {
      const user = await getLoginUser();
      setState({
        user,
        pending: false
      })
    } catch (e) {
      setState({ pending: false })
    }
  }

  useEffect(() => {
    _get()
  }, [])

  return { ...state }
}

// 收下蛋糕
export function collectCake() {
  return axiosInstance.post(API_COLLECT_GIFT, {
    ck: Cookie.get('ck')
  }).then((res: AxiosResponse<{
    has_collected: boolean
  }>) => {
    // console.log('res - ', res)
    return res.data
  }).catch((error: AxiosError) => {
    return {
      has_collected: false,
      ...error.response
    }
  })
}

// 领取邀请券
export function collectInvitationLetter() {
  return axiosInstance.post(API_COLLECT_INVITATION_LETTER, {
    // ck: Cookie.get('ck')
  }).then((res: AxiosResponse<{
    has_invited_all: boolean
  }>) => {
    // console.log('111 res - ', res)
    return res.data
  }).catch((error: AxiosError) => {
    // console.log('111 error - ', error.response)
  })
}
